
import { FC, ReactNode, useEffect } from "react";
import { useNavigate, useLocation } from "@tanstack/react-router";
import { useAuthStore } from "~/stores/auth-store";
import { LoginLockedModalTrigger } from "./login-locked-modal-trigger";

interface AuthGuardProps {
  children: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const { _hasHydrated, isAuthenticated, checkAuthStatusAction, user } = useAuthStore();

  useEffect(() => {
    // Chỉ chạy logic check auth cơ bản và redirect login/dashboard khi hydrate xong
    if (_hasHydrated) {
      checkAuthStatusAction(pathname, navigate);
    }
  }, [pathname, navigate, checkAuthStatusAction, _hasHydrated]);

  if (!_hasHydrated) {
    return null; // Tránh hydration mismatch
  }

  // Basic failsafe check
  if (!isAuthenticated && pathname !== "/login" && pathname !== "/register" && pathname !== "/samtek/login") {
    return null;
  }

  // is_login_locked = true + id_product = 1  → bắt buộc nâng cấp gói
  const isLockedUpgrade = isAuthenticated && user?.is_login_locked === true && user?.id_product === 1;

  // is_login_locked = true + id_product != 1 → bắt buộc gia hạn gói
  const isLockedRenew = isAuthenticated && user?.is_login_locked === true && (user?.id_product ?? 0) > 1;

  return (
    <>
      {children}
      {isLockedUpgrade && <LoginLockedModalTrigger mode="upgrade" />}
      {isLockedRenew && <LoginLockedModalTrigger mode="renew" />}
    </>
  );
};

export default AuthGuard;
